// Split a line of reveal text so the person it is about can be picked out at a
// glance. "Recently" is a wall of similar-looking sentences otherwise, and the
// first thing anyone wants to know is who it is about.

export interface TextPart {
  text: string;
  isName: boolean;
}

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Longest first, so "Marcus Green" wins over "Marcus" and we never highlight a
// first name sitting inside the full name we already matched.
function candidates(name: string): string[] {
  const full = name.trim();
  if (!full) return [];
  const parts = full.split(/\s+/).filter((p) => p.length > 1);
  return [...new Set([full, ...parts])].sort((a, b) => b.length - a.length);
}

export function highlightName(text: string, name?: string | null): TextPart[] {
  if (!text) return [];
  const names = name ? candidates(name) : [];
  if (names.length === 0) return [{ text, isName: false }];

  // Word boundaries so "Al" does not light up inside "already".
  const pattern = new RegExp(`\\b(${names.map(escapeRegex).join("|")})\\b`, "gi");
  const out: TextPart[] = [];
  let last = 0;
  for (const m of text.matchAll(pattern)) {
    const at = m.index ?? 0;
    if (at > last) out.push({ text: text.slice(last, at), isName: false });
    out.push({ text: m[0], isName: true });
    last = at + m[0].length;
  }
  if (last < text.length) out.push({ text: text.slice(last), isName: false });
  return out.length > 0 ? out : [{ text, isName: false }];
}
